<sh-notification-item id="timeline-notification-item-1"
  [message]="timeline?.translation ? ('timeline.disclaimer.withTranslation' | transloco: { from: timeline.translation.from_language, to: timeline.translation.to_language }) : ('timeline.disclaimer.default' | transloco)"
  inline visible style="margin-bottom: 16px;">
</sh-notification-item>
@if (timeline?.summary) {
  <sh-text id="timeline-text-2">
    <b>{{ 'timeline.summaryLabel' | transloco }}</b> {{ timeline.summary }}
  </sh-text>
}
<p-timeline [value]="timeline.timeline" align="left" layout="vertical" styleClass="custom-timeline">
  <ng-template #marker let-event>
    <sh-icon id="timeline-icon-recording" icon="recording" size="xs"></sh-icon>
  </ng-template>
  <ng-template #content let-event>
    <div style="display: flex; flex-direction: column;">
      <p class="body-100 color-subtle">{{ event.date }}</p>
      <sh-text id="timeline-text-4">{{ event.summary }}</sh-text>
    </div>
  </ng-template>
</p-timeline>